import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Parc from "../views/Parc.vue";
import AddParc from "../views/Parc/AddParc.vue" ;
import ModifierParc from "@/views/Parc/ModifierParc.vue"; 
import Billing from "../views/Billing.vue";
import RTL from "../views/Rtl.vue";
import Notifications from "../views/Notifications.vue";
import Profile from "../views/Profile.vue";
import SignIn from "../views/SignIn.vue";
import SignUp from "../views/SignUp.vue";
import Materiall from "../views/Materiall.vue";
import AddMateriel from "../views/Materiall/AddMateriel.vue" ;
import ModifierMaterial from "@/views/Materiall/ModifierMaterial.vue"; 
import AddEmployee from "../views/Employees/AddEmployee.vue" ;
import EmployeeDocuments from "@/views/Employees/EmployeeDocuments.vue";
import BankAccountDetails from "@/views/Employees/BankAccountDetails.vue";
import BankDetailsEdit from "@/views/Employees/BankDetailsEdit.vue";
import BankManagement from '@/views/reference-data/banks/BankManagement.vue'
import ProjectManagement from '@/views/reference-data/projects/ProjectManagement.vue'
import BudgetCategoryManagement from '@/views/reference-data/budget-categories/BudgetCategoryManagement.vue'
import BudgetSubCategoryManagement from '@/views/reference-data/budget-sub-categories/BudgetSubCategoryManagement.vue'
import PositionManagement from '@/views/reference-data/positions/PositionManagement.vue'
import CompanyManagement from '@/views/reference-data/companies/CompanyManagement.vue'
import ContractTypeManagement from '@/views/reference-data/contract-types/ContractTypeManagement.vue'
import PersonalInformation from '@/views/Employees/PersonalInformation.vue'
import ProfessionalInformation from '@/views/Employees/ProfessionalInformation.vue'
import EmployeeList from '@/views/Employees/EmployeeList.vue'
import EditEmployee from '@/views/Employees/EditEmployee.vue'
import EditPersonalInformation from '@/views/Employees/EditPersonalInformation.vue'
import EditProfessionalInformation from '@/views/Employees/EditProfessionalInformation.vue'
import EditDocuments from '@/views/Employees/EditDocuments.vue'
import DocumentTypeManagement from '@/views/reference-data/document-type/DocumentTypeManagement.vue'
import BonusManagement from '@/views/reference-data/bonus/BonusManagement.vue'
import ContractList from '@/views/Contracts/ContractList.vue'
import AddContract from '@/views/Contracts/AddContract.vue'
import EditContract from '@/views/Contracts/EditContract.vue'
import EmployeeLeave from '@/views/Employees/Leaves/EmployeeLeave.vue'
import LeaveManagement from '@/views/Employees/Leaves/LeaveManagement.vue'
import EmployeeLeavesRouter from '@/views/Employees/Leaves/EmployeeLeavesRouter.vue'
import LeaveReview from '@/views/Employees/Leaves/LeaveReview.vue'
import EmployeeLoansRouter from '@/views/Employees/Loans/EmployeeLoansRouter.vue'
import LoanRequest from '@/views/Employees/Loans/LoanRequest.vue'
import LoanReview from '@/views/Employees/Loans/LoanReview.vue'
import SalaryAdvanceList from "@/views/Employees/SalaryAdvance/SalaryAdvanceList.vue";
import SalaryAdvanceRequest from "@/views/Employees/SalaryAdvance/SalaryAdvanceRequest.vue";
import SalaryAdvanceReview from "@/views/Employees/SalaryAdvance/SalaryAdvanceReview.vue";
import CertificateTypeManagement from '@/views/reference-data/certificate-types/CertificateTypeManagement.vue'
import CertificateRedirect from '@/views/Employees/certificates/CertificateRedirect.vue'
import CertificateRequest from '@/views/Employees/certificates/CertificateRequest.vue'
import CertificateReview from '@/views/Employees/certificates/CertificateReview.vue'
import ExpenseCategoryManagement from '@/views/reference-data/expense-categories/ExpenseCategoryManagement.vue'
import OfficeExpensesDashboard from '@/views/office-expenses/OfficeExpensesDashboard.vue'
import ExpenseManagement from '@/views/office-expenses/expenses/ExpenseManagement.vue'
import AddIncome from '@/views/office-expenses/incomes/AddIncome.vue'
import EditIncome from '@/views/office-expenses/incomes/EditIncome.vue'
import AddExpenses from '@/views/office-expenses/expenses/AddExpenses.vue'
import EditExpense from '@/views/office-expenses/expenses/EditExpense.vue'
import TrainingReservations from '@/views/training-reservations/TrainingReservations.vue'
import TrainingCalendar from '@/views/training-reservations/TrainingCalendar.vue'
import SalaryList from '@/views/salary/SalaryList.vue'
import AddSalary from '@/views/salary/AddSalary.vue'
import EditSalary from '@/views/salary/EditSalary.vue'
import SalaryDetails from '@/views/salary/SalaryDetails.vue'
import BonusList from '@/views/bonus/BonusList.vue'
import AddBonus from '@/views/bonus/AddBonus.vue'
import BonusDetails from '@/views/bonus/BonusDetails.vue'
import EditBonus from '@/views/bonus/EditBonus.vue'
import AuthorizationRequest from '@/views/Employees/authorization/AuthorizationRequest.vue'
import AuthorizationReview from '@/views/Employees/authorization/AuthorizationReview.vue'
import AuthorizationHistory from '@/views/Employees/authorization/AuthorizationHistory.vue'
import Attendance from '@/views/Employees/attendance/Attendance.vue'
import EmployeeProfile from '@/views/EmployeeProfile.vue';
import EditEmployeeProfile from "../views/EditEmployeeProfile.vue";
import EmployeeMyBonus from "../views/EmployeeMyBonus.vue";
import EmployeeBankDetailsUser from "@/views/EmployeeBankDetailsUser.vue";
import EmployeeProfessionalInfo from "@/views/Employees/EmployeeProfessionalInfo.vue";
import DocumentsEmployee from "@/views/Employees/DocumentsEmployee.vue";




function getCurrentRole() {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  return (
    user?.role ||
    (Array.isArray(user?.roles)
      ? (typeof user.roles[0] === 'string' ? user.roles[0] : user.roles[0]?.name)
      : null)
  )
}




const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/sign-in", 
  },
  
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: '/reference/projects',
    name: 'ProjectManagement',
    component: ProjectManagement,
    meta: { requiresAuth: true },
  },
  {
    path: '/reference/positions',
    name: 'PositionManagement',
    component: PositionManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/reference/banks',
    name: 'BankManagement',
    component: BankManagement,
    meta: { requiresAuth: true }
  },
  {
  path: '/reference/certificate-types',
  name: 'CertificateTypeManagement',
  component: CertificateTypeManagement,
  meta: { requiresAuth: true }
},
  {
    path: "/materiall",
    name: "Material",
    component: Materiall,
  },
  {
    path: "/parc",
    name: "Parc",
    component: Parc,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/sign-in",
    name: "SignIn",
    component: SignIn,
    
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: SignUp,
  },

  {
    path: "/add-materiel",
    name: "AddMateriel",
    component:AddMateriel,
  },
  {
    path: "/add-parc",
    name: "AddParc",
    component: AddParc,
  },
  {
    path: "/add-employee",
    name: "AddEmployee",
    component:AddEmployee,
  },
  {
    path: "/modifier-material/:id",
    name: "ModifierMaterial",
    component: ModifierMaterial,
     },
  {
    path: "/modifier-parc/:id",
    name: "ModifierParc",
    component: ModifierParc,
  },
  {
     path: '/employee-documents',
  name: 'EmployeeDocuments',
    component: EmployeeDocuments,
  },
 {
  path: "/employee/bank-details",
  name: "BankAccountDetails",
  component: BankAccountDetails,
},

{
  path: "/employee/bank-details/edit",
  name: "BankDetailsEdit",
  component: BankDetailsEdit,
},


  {
    path: '/reference/budget-category',
    name: 'BudgetCategoryManagement',
    component: BudgetCategoryManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/reference/budget-sub-category',
    name: 'BudgetSubCategoryManagement',
    component: BudgetSubCategoryManagement,
    meta: { requiresAuth: true }
  },

  {
    path: '/reference/companies',
    name: 'CompanyManagement',
    component: CompanyManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/reference/contract-types',
    name: 'ContractTypeManagement',
    component: ContractTypeManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/employee/information',
    name: 'PersonalInformation',
    component: PersonalInformation
  },
  {
    path: '/employee/information/professional',
    name: 'ProfessionalInformation',
    component: ProfessionalInformation
  },
  {
    path: '/employees',
    name: 'EmployeeList',
    component:EmployeeList
  },
  {
    path: '/edit-employee',
    name: 'EditEmployee',
    component:EditEmployee
  },
  {
    path: '/employee/information/edit',
    name: 'EditPersonalInformation',
    component: EditPersonalInformation
  },
  {
    path: '/employee/information/professional/edit',
    name: 'EditProfessionalInformation',
    component: EditProfessionalInformation,
    meta: { requiresAuth: true }
  },
  {
    path: '/employee/information/documents',
    name: 'EditDocuments',
    component: EditDocuments,
    meta: { requiresAuth: true }
  },
  {
    path: '/reference/document-type',
    name: 'DocumentTypeManagement',
    component: DocumentTypeManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/reference/bonus',
    name: 'BonusManagement',
    component: BonusManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/contracts',
    name: 'ContractList',
    component: ContractList,
    meta: { requiresAuth: true }
  },
  {
    path: '/add-contract',
    name: 'AddContract',
    component: AddContract,
    meta: { requiresAuth: true }
  },
  {
    path: '/edit-contract/:id',
    name: 'EditContract',
    component: EditContract,
    meta: { requiresAuth: true }
  },

{
  path: '/employee/leaves',
  name: 'EmployeeLeavesRouter',
  component: EmployeeLeavesRouter,
  meta: { requiresAuth: true }
},


{
  path: '/employee/leaves/request',
  name: 'LeaveRequest',
  component: EmployeeLeave,
  meta: { requiresAuth: true }
},


{
  path: '/employee/leaves/review',
  name: 'LeaveReview',
  component: LeaveReview,
  meta: { requiresAuth: true }
},


{
  path: '/employee/leaves/manage',
  name: 'LeaveManagement',
  component: LeaveManagement,
  meta: { requiresAuth: true }
},
  
{
  path: '/employee/loans',
  name: 'EmployeeLoansRouter',
  component: EmployeeLoansRouter,
  meta: { requiresAuth: true }
},
{
  path: '/employee/loans/request',
  name: 'LoanRequest',
  component: LoanRequest,
  meta: { requiresAuth: true }
},
{
  path: '/employee/loans/review',
  name: 'LoanReview',
  component: LoanReview,
  meta: { requiresAuth: true }
},
{
    path: '/employee/salary-advances',
    name: 'SalaryAdvanceList',
    component: SalaryAdvanceList,
    meta: { requiresAuth: true }
  },
  {
    path: '/employee/salary-advances/request',
    name: 'SalaryAdvanceRequest',
    component: SalaryAdvanceRequest,
    meta: { requiresAuth: true }
  },
  {
    path: '/employee/salary-advances/review',
    name: 'SalaryAdvanceReview',
    component: SalaryAdvanceReview,
    meta: { requiresAuth: true }
  },
  {
  path: '/employee/certificate-requests',
  name: 'CertificateRedirect',
  component: CertificateRedirect,
  meta: { requiresAuth: true }
},
{
  path: '/employee/certificate-requests/request',
  name: 'CertificateRequest',
  component: CertificateRequest,
  meta: { requiresAuth: true }
},
{
  path: '/employee/certificate-requests/review',
  name: 'CertificateReview',
  component: CertificateReview,
  meta: { requiresAuth: true }
},
{
  path: '/office-expenses',
  name: 'OfficeExpenses',
  component: OfficeExpensesDashboard
},
{
  path: '/office-expenses/expenses',
  name: 'ExpenseManagement',
  component: ExpenseManagement
},
 
  {
    path: '/office-expenses/incomes/add',
    name: 'AddIncome',
    component: AddIncome
  },
  {
     path: '/office-expenses/incomes/edit/:id',
  name: 'EditIncome',
    component: EditIncome
  },
  {
    path: '/office-expenses/expenses/add',
    name: 'AddExpenses',
    component: AddExpenses
  },
  {
    path: '/reference/expense-categories',
    name: 'ExpenseCategories',
    component: ExpenseCategoryManagement
  },
  {
  path: '/office-expenses/expenses/edit/:id',
  name: 'EditExpense',
  component: EditExpense
},
{
  path: '/training-reservations',
  name: 'TrainingReservations',
  component: TrainingReservations,
},
{
  path: '/training-calendar',
  name: 'TrainingCalendar',
  component: TrainingCalendar,
},

 {
    path: '/salary',
    name: 'SalaryList',
    component:SalaryList
  },
 {
  path: '/edit-salary/:id', 
  name: 'EditSalary',
  component: EditSalary,
  props: true  
},
  
  {
    path: '/add-salary',
    name: 'AddSalary',
    component:AddSalary
  },
  {
  path: '/salary-details/:id',
  name: 'SalaryDetails',
  component:SalaryDetails
},
{
  path: '/bonus-list',
  name: 'BonusList',
  component: BonusList,
  meta: { requiresAuth: true, title: 'Liste des Bonus' }
},
{
  path: '/bonuses',
  redirect: '/bonus-list'
},
{
  path: '/add-bonus',
  name: 'AddBonus',
  component: AddBonus,
  meta: { requiresAuth: true, title: 'Ajouter un Bonus' }
},
{
  path: '/edit-bonus/:id',
  name: 'EditBonus',
  component: EditBonus,
  meta: { requiresAuth: true, title: 'Modifier le Bonus' }
},
{
  path: '/bonus-details/:id',
  name: 'BonusDetails',
  component: BonusDetails,
  meta: { requiresAuth: true, title: 'Détails du Bonus' }
}
,
// ---------- AUTHORIZATION HOME (redirige selon le rôle) ----------
{
  path: '/authorization',
  name: 'AuthorizationHome',
  meta: { requiresAuth: true },
  beforeEnter: (to, from, next) => {
    const role = getCurrentRole()
    if (role === 'admin') next({ name: 'AuthorizationReview' })   
    else next({ name: 'AuthorizationHistory' })                   
  }
},

{
  path: '/authorization',
  redirect: { name: 'AuthorizationHistory' }  
},
{
  path: '/authorization-request',
  name: 'AuthorizationRequest',
  component: AuthorizationRequest,
  meta: { requiresAuth: true }
},
{
  path: '/authorization-history',
  name: 'AuthorizationHistory',
  component: AuthorizationHistory,
  meta: { requiresAuth: true }
},
{
  path: '/authorization-review',
  name: 'AuthorizationReview',
  component: AuthorizationReview,
  meta: { requiresAuth: true }
},

{
  path: "/employee/attendance",
  name: "EmployeeAttendance",
  component:Attendance,
  meta: { requiresAuth: true },
},
    {
      path: '/employee/profile', 
      name: 'EmployeeProfile',
      component: EmployeeProfile,  
    },
    {
  path: "/edit-employee-profile",
  name: "EditEmployeeProfile",
  component: EditEmployeeProfile,
},
{
  path: "/employee/my-bonus",
  name: "EmployeeMyBonus",
  component: EmployeeMyBonus,
  meta: { requiresAuth: true },
},
{
  path: "/employee/bank-details-user",
  name: "EmployeeBankDetailsUser",
  component: EmployeeBankDetailsUser,
},
{
  path: "/employee/professional-info",
  name: "EmployeeProfessionalInfo",
  component: EmployeeProfessionalInfo,
},
{
  path: "/employee/my-documents",
  name: "DocumentsEmployee",
  component: DocumentsEmployee,
},






 
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});
// Garde de navigation
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.meta.requiresAuth && !token) {
    next("/sign-in");
  } else {
    next();
  }
});

export default router;
